import { render, staticRenderFns } from "./AccountDetail.vue?vue&type=template&id=52cf7106&scoped=true&"
import script from "./AccountDetail.vue?vue&type=script&lang=js&"
export * from "./AccountDetail.vue?vue&type=script&lang=js&"
import style0 from "./AccountDetail.vue?vue&type=style&index=0&id=52cf7106&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cf7106",
  null
  
)

export default component.exports